export enum Currency {
  None = 0,
  Usd = 1,
  Eur = 2,
  Pln = 3,
  Nok = 4,
  Sek = 5,
}
